import React, { useState } from 'react'
import { useRequest, useUpdateEffect } from 'ahooks'
import axios from 'axios';
import { baseURL } from '../../../service';

export default function useCameraService() {

    const [faceResult, setFaceResult] = useState(null);

    const facePost = (fileStr) => axios({
        method: 'post',
        url: baseURL + '/user/faceValidate',
        headers: {
            get 'userId'() {
                return localStorage.getItem('userId')
            },
            'content-type': 'application/json'
        },
        data: { fileStr }
    });

    const { run: faceCompare } = useRequest((params) => facePost(params), {
        manual: true,
        onSuccess: (res, param) => {
            if (res.data.status) {
                setFaceResult(true)
            } else {
                setFaceResult(false)
            }
        },
        onError: (res, param) => {

        }
    })

    // useUpdateEffect(() => {
    //     console.log('faceResult', faceResult)
    // }, [faceResult])

    return { faceResult, setFaceResult, faceCompare }

}
